import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Flex } from '../../common';
import { RouteInfo } from '../../components/RouteInfo/RouteInfo';
import { decodeUrl } from '../../helpers';
import { useForm } from '../../hooks/useForm';
import { useNotification } from '../../hooks/useNotification';
import { useTicket } from '../../hooks/useTicket';
import { CreateReply } from './CreateReply';
import { MessagesAndFormContainer, MessagesList } from './InternalSupportTicket.style';

import { InternalSupportTicketDetail } from './InternalSupportTicketDetail';
import { InternalSupportTicketMessages } from './InternalSupportTicketMessages';

type Reply = { reply: string };

export const InternalSupportTicket = () => {
  const { notify, notifyError } = useNotification();
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(false);
  const id = decodeUrl(pathname);
  const { ticket, reply } = useTicket(id);
  const { values, onChange, forceChange } = useForm<Reply>({
    reply: '',
  });
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!values.reply) {
      notifyError('Plese provide message!');
      return;
    }
    setLoading(true);
    try {
      const res = await reply(values.reply);
      if (!res?.data.error) {
        notify({ message: res?.data.message });
        forceChange('', 'reply');
        setLoading(false);
      } else {
        notifyError(res?.data.message);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <RouteInfo
        banner="Internal Support"
        description="Manage internal support tickets"
        smImage="/internal-support-sm.png"
        noButton
        noLastRoute
      />
      <Flex column>
        <InternalSupportTicketDetail onClick={() => navigate(-1)} agent={ticket?.agent?.name} />
        <MessagesAndFormContainer>
          <MessagesList>
            {ticket?.messages.map(
              (
                message: {
                  body: string;
                  date: number;
                  from: { photo: string; name: string; email: string };
                  id: string;
                  isFromExternalSupport: boolean;
                  subject: string;
                },
                index: number,
              ) => (
                <InternalSupportTicketMessages
                  key={id}
                  resolved={ticket?.resolved}
                  main={index === 0}
                  {...message}
                />
              ),
            )}
          </MessagesList>

          {!ticket?.resolved && (
            <CreateReply
              value={values.reply}
              onChange={onChange}
              handleSubmit={handleSubmit}
              loading={loading}
              exportExternal={ticket?.exportExternal}
            />
          )}
        </MessagesAndFormContainer>
      </Flex>
    </>
  );
};
